<template>
  <Carte
    :content="jel_isCarteLarge(content) ? contentCarte : content"
    :class="'nb-colonne-' + content.nbColonne"
  >
    <b-container
      class="h-100"
      :class="[
        { 'p-0': content.nbColonne == 2 },
        jel_isCarteLarge(content) ? 'py-1 carte-large' : { 'py-0': content.titre },
      ]"
    >
      <div class="m-0 h-100" :class="typeCarteListe">
        <b-col v-if="content.titre" class="m-0 p-0 d-flex titre-carte">
          <b-link
            v-bind="jel_getLienBinding(content.lien)"
            class="graphik_black w-100 d-flex align-items-center bordure-titre"
          >
            {{ content.titre }}
            <b-icon
              v-if="!jel_getLienBinding(content.lien).disabled"
              scale="0.7"
              icon="chevron-right"
              class="d-none d-xl-flex"
            />
          </b-link>
        </b-col>
        <b-col
          v-for="(itemElement, index) in getElements"
          :key="index"
          :class="content.nbColonne == 2 ? 'liste-2-colonnes' : 'liste-1-colonne px-0'"
        >
          <slot name="element" :itemElement="itemElement" :elementPremiereLigne="index < 2"></slot>
        </b-col>
      </div>
    </b-container>
  </Carte>
</template>

<script>
import { mapGetters } from 'vuex';
import Carte from '@/components/base/carte/Carte';

export default {
  name: 'CarteListe',
  components: {
    Carte,
  },
  props: {
    content: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      getProduitsByCollectionUuid: 'produitCollection/getArrayProduitByUuidProduitCollection',
    }),
    contentCarte() {
      return {
        ...this.content,
        formatCarte: this.jel_isCarteLarge(this.content) ? '4x3' : this.content.formatCarte,
      };
    },
    isCarteLarge() {
      return this.jel_isCarteLarge(this.content) && this.content.nbColonne == 1;
    },
    getElements() {
      let listeElements = [];
      if (this.content.idProduitCollection) {
        listeElements = listeElements.concat(
          this.getProduitsByCollectionUuid(this.content.idProduitCollection)
        );
      }
      listeElements = listeElements.concat(this.content.listeElement);
      return listeElements.slice(0, this.getNbElements);
    },
    getNbElements() {
      return this.content.nbMaxProduitsAffiches || (this.content.nbColonne == '1' ? 5 : 4);
    },
    typeCarteListe() {
      if (this.content.nbColonne == 1) {
        if (this.content.titre) {
          return 'liste-1x4-titre';
        }
        if (this.content.nbLigne == 4) {
          return 'liste-1x4-sans-titre';
        }
        return 'liste-1x5';
      }
      return 'liste-2x2 row row-cols-2 justify-content-start';
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  color: black !important;
}

.nb-colonne-2 div.row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: baseline;
}
.carte-large {
  .titre-carte {
    a {
      padding-bottom: 5px;
    }
  }
}

.titre-carte {
  height: 10%;
  a {
    color: $couleur-bleu-fonce-lq;

    svg {
      margin-left: 0.25rem;
      color: #1928729a;
    }
    &:hover {
      text-decoration: none;
    }
  }
}

.bordure-titre::after {
  border-bottom: 1px #e2e7f0 solid;
  content: '';
  position: absolute;
  bottom: 0;
  left: -20px;
  width: 125%;
}

.container {
  max-width: none;
}

.liste-2-colonnes {
  &:nth-child(even) {
    padding-left: 0.25rem;
    padding-right: 1.45rem;
  }
  &:nth-child(odd) {
    padding-left: 1.45rem;
    padding-right: 0.25rem;
  }
  // &:nth-child(-n + 2) {
  // padding-bottom: 0.3rem;
  // }
  &:nth-child(n + 3) {
    padding-top: 0.4rem;
  }
}

.liste-1-colonne:last-child::v-deep .info-produit {
  border-bottom: none;
}

.liste-1-colonne:last-child::v-deep .info-produit:after {
  border-bottom: none;
}

::v-deep {
  .titre-jeu,
  .mise-jeu {
    letter-spacing: $letter-spacing-n1;
  }
}

// ajout de padding au premier jeu de la liste 1x4 avec titre seulement
.app_contenu main .row.no-gutters:first-child .col:nth-child(2) {
  padding-top: 0.5rem;
}

.liste-1x5 {
  .liste-1-colonne {
    height: 20%;
  }
}

.liste-1x4-titre {
  .liste-1-colonne {
    height: 22.5%;
  }
}
.liste-1x4-sans-titre {
  .liste-1-colonne {
    height: 25%;
  }
}
.liste-2x2 {
  .liste-2-colonnes {
    height: 50%;
  }
}
// ios 14.1 a 14.5 (fix aussi pour ios 13)
@supports (-webkit-touch-callout: none) and (not (translate: none)) {
  .titre-carte {
    padding-bottom: 1.5rem !important;
  }
  .app_contenu main .row.no-gutters:first-child .col {
    padding-top: 1rem;
  }
  .liste-1x4-titre {
    padding-top: 2rem;
    .liste-1-colonne {
      min-height: 9vh;
    }
  }
}
//MAC os Catalina Safari v13.1
@media not all and (min-resolution: 0.001dpcm) {
  @supports not (-webkit-touch-callout: none) {
    .titre-carte {
      padding-bottom: 1.5rem !important;
    }
    .app_contenu main .row.no-gutters:first-child .col {
      padding-top: 1rem;
    }

    .liste-1x4-titre {
      padding-top: 2rem;
    }
    .liste-1-colonne {
      min-height: 9vh;
      ::v-deep .image-produit {
        height: 87px !important;
      }
    }
  }
}
</style>
